export const GET_PRODUCTS_BY_PAGE_NAME_START = "GET_PRODUCTS_BY_PAGE_NAME_START";
export const GET_PRODUCTS_BY_PAGE_NAME_SUCCESS = "GET_PRODUCTS_BY_PAGE_NAME_SUCCESS";
export const GET_PRODUCTS_BY_PAGE_NAME_FAIL = "GET_PRODUCTS_BY_PAGE_NAME_FAIL";

export const GET_PRODUCTS_DATA = "GET_PRODUCTS_DATA";

export const PRODUCTS_RESET = "PRODUCTS_RESET";
